module.exports = __webpack_public_path__ + "img/logo-lps-putih 1.3bda31fb.png";